export default "__VITE_ASSET__Czs_Y$m7__"